import { Component, EventEmitter, Input, OnDestroy, Output, ChangeDetectionStrategy } from '@angular/core';
import { OverlayTemplate, SidebarService } from '../../service/sidebar.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SidebarComponent implements OnDestroy {
  constructor(private sidebarService: SidebarService) {
    this.sidebarService.overlayContent$
      .pipe(takeUntil(this.destroy$))
      .subscribe(content => this.overlayContent = content);
  }

  private destroy$ = new Subject<void>();
  overlayContent: OverlayTemplate;
  @Input() isOpen: boolean;
  @Input() showDefaultHeader: boolean = true; // remove basic header line with close sidebar button
  @Input() bigSize: boolean = true;
  @Output() close = new EventEmitter<boolean>();

  closeSidebar() {
    this.close.emit(this.isOpen);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
